import $ from 'jquery';
import page from 'page';
import BluebirdPromise from 'bluebird';
import moment from 'moment';
import Vue from 'vue';
import ko from 'knockout';
import koMapping from 'knockout.mapping';
import pikaday from 'pikaday';
import plainOverlay from 'plain-overlay';
import initDelegateEvents from './vendor/knockout-delegatedEvents';
import initObservableDictionary from './vendor/knockout.observableDictionary';
import * as Keys from './common/keys';
import * as ajax from './common/ajax';
import forms from './common/forms';
import post from './common/post';
import updateQueryStringParam from './common/updateQueryStringParam';
import * as numberValidation from './common/number-validation';
import BrowserSupport from './common/browser-support';
import { toMonthName, toNorskDatoMedTid } from './common/dato-hjelper';
import Chart from '../../node_modules/chart.js/dist/Chart.min';
import './common/custom-ko-mappings';
import './common/init-popups';
import './common/init-form-links';
import './common/ios-orientation-fix';

window.$ = $;
window.jQuery = $;
ko.mapping = koMapping;
const baseUrl = $('base').attr('href');

// run some stuff on all pages
initDelegateEvents(ko, (ko.actions = {}));
initObservableDictionary(ko);

export {
  $,
  ajax,
  baseUrl,
  BluebirdPromise,
  BrowserSupport,
  Chart,
  forms,
  Keys,
  ko,
  moment,
  numberValidation,
  page,
  pikaday,
  plainOverlay,
  post,
  toMonthName,
  toNorskDatoMedTid,
  updateQueryStringParam,
  Vue,
};
